import Button from "components/Button"
import { useEffect, useState, useRef } from "react"
import AddFile from "components/AddFile"
import { useDispatch, useSelector } from "react-redux";
import { setFiles } from "store/slices/vaultSlice"
import { RootState } from "store";
import { getFiles } from "services/patient/vault"
import VaultFileCard from "components/VaultFileCard";
import newFile from 'assets/images/newFile.png'




const Vault = () => {

    const dispatch = useDispatch();
    const files = useSelector((state:RootState )=> state.fileData.files)

    const [ err, setErr ] = useState('')
    const [ showUploadFileModal, toggleModal ] = useState(false)

    useEffect(()=> {
        getFiles().then(
            res => {
               dispatch(setFiles(res.data.result))
            }
        )
    },[dispatch])

    return(
            <div className="w-full flex relative" >
                <AddFile show={showUploadFileModal} toggleClose={()=>toggleModal(!showUploadFileModal)} />
         
            <div  className={`w-full p-10 ${showUploadFileModal ? '' : 'lg:screen' }`}>
                <div className="flex justify-between" >
                    <div className="flex flex-col justify-center mb-8" >
                        <p className=" text-secondary text-sm cursor-pointer mb-2" onClick={()=>toggleModal(!showUploadFileModal)} >
                        <img className="md:h-14 md:w-14 lg:w-18 lg:h-18 xl:w-20 xl:h-20 w-20 h-10 bg"  src={newFile} alt={"+ file"} /> 
                        </p>
                    </div>
                </div>
                <div className="my-6 h-full w-full grid grid-cols-4 gap-4" >
                {
                    files.map((file, index:number) => (
                        <div className="w-full h-52 mb-2 ">
                             <VaultFileCard icon={file.file_url} description ={file.description}/>
                            
                        </div>
                    ))
                }                   
                </div>
            </div>
        </div>
    )
}

export default Vault
